<script setup>
  import PhoneLogin from '@/components/user/PhoneLogin.vue'
</script>
<template>
  <PhoneLogin />
</template>